export default () => ({
    root: {
        overflow: 'hidden',
        transitionProperty: 'height',
        transitionTimingFunction: 'ease-in-out',
    },
    open: {
        overflow: 'visible',
    },
    animating: {
        overflow: 'hidden',
    },
    noTransition: {
        transition: 'none !important',
    },
    animateOpacity: {
        '& $content': {
            opacity: 0,
            transition: 'opacity inherit',
        },
        '&$open $content': {
            opacity: 1,
        },
    },
    content: {},
});
